import { TEMPLATE_IDS, type TTemplateId } from "@lexicanon/shared"
import type { I18n } from "@lingui/core"
import { msg } from "@lingui/core/macro"

/**
 * Lingui-wrapped display label for a built-in template id.
 *
 * The ids + their English source strings live in `@lexicanon/shared`
 * (`TEMPLATE_IDS` / `TEMPLATE_LABELS`); TRANSLATION stays here at the UI layer.
 * Every Select that offers a template picker derives its options from
 * `templateOptions(i18n)` so the wording can't fork (it previously had:
 * "D&D Companion" vs "D&D / TTRPG Companion").
 */
export function templateLabel(i18n: I18n, id: TTemplateId): string {
  switch (id) {
    case "dnd-companion":
      return i18n._(msg`D&D Companion`)
    case "meeting-intelligence":
      return i18n._(msg`Meeting Intelligence`)
    case "meeting-lite":
      return i18n._(msg`Meeting Lite`)
  }
}

export interface ITemplateOption {
  value: TTemplateId
  label: string
}

/**
 * Templates offered in series / campaign / profile pickers.
 * `meeting-lite` is a per-meeting pipeline, not a workspace default.
 */
export const PICKABLE_TEMPLATE_IDS: readonly TTemplateId[] = TEMPLATE_IDS.filter((id) => id !== "meeting-lite")

/** Built-in template ids as `{ value, label }` Select options (stable order). */
export function templateOptions(i18n: I18n): ITemplateOption[] {
  return PICKABLE_TEMPLATE_IDS.map((id) => ({ value: id, label: templateLabel(i18n, id) }))
}
